import { z } from 'zod';

import { zodAddressSchema } from '@vestigas/data';

import {
  SUPPLIER_REQUEST_ENRICHMENT_STATUS,
  SUPPLIER_REQUEST_RESEARCHED_DATA_STATUS,
  SUPPLIER_REQUEST_STATE,
} from '../constants';
import {
  zodCompanyAccountRefSchema,
  zodCompanyRefSchema,
  zodGlnSchema,
  zodResolvedCompanyRefSchema,
  zodSubmittedSupplierInfoSchema,
  zodVatIdSchema,
} from '../validations';

/**
 * TODO: the search agent currently returns non-standard addresses, so we need to extend the schema to match.
 * Search-agent addresses currently alias `buildingNumber`/`postCode` as
 * `houseNumber`/`postalCode`. Drop the `.extend(...)` once the API matches
 * `zodAddressSchema`.
 */
const zodResearchedAddressSchema = zodAddressSchema.extend({
  houseNumber: zodAddressSchema.shape.buildingNumber,
  postalCode: zodAddressSchema.shape.postCode,
});

const zodResearchedRegisterEntrySchema = z.object({
  registerCourt: z.string().nullish(),
  registerNumber: z.string().nullish(),
  registerType: z.string().nullish(),
});

const zodResearchedCompanySchema = z.object({
  address: zodResearchedAddressSchema.nullish(),
  glns: z.array(zodGlnSchema).optional().prefault([]),
  name: z.string().nullish(),
  registerEntries: z
    .array(zodResearchedRegisterEntrySchema)
    .optional()
    .prefault([]),
  vatId: zodVatIdSchema.nullish(),
  websiteUrls: z.array(z.string()).optional().prefault([]),
});

export const zodSupplierRequestResearchedSchema = z.object({
  company: zodResearchedCompanySchema.nullish(),
  status: z.enum(SUPPLIER_REQUEST_RESEARCHED_DATA_STATUS),
});

export const zodSupplierRequestDetailResponseSchema = z.object({
  createdAt: z.iso.datetime({ offset: true }),
  createdByUserId: z.uuid(),
  enrichmentStatus: z.enum(SUPPLIER_REQUEST_ENRICHMENT_STATUS).nullish(),
  id: z.uuid(),
  potentialDuplicateCompanyIds: z.array(z.uuid()).optional().prefault([]),
  rejectionReason: z.string().nullish(),
  requestingCompany: zodCompanyRefSchema,
  requestingCompanyAccount: zodCompanyAccountRefSchema,
  researched: zodSupplierRequestResearchedSchema.nullish(),
  resolvedCompany: zodResolvedCompanyRefSchema.nullish(),
  state: z.enum(SUPPLIER_REQUEST_STATE),
  submitted: zodSubmittedSupplierInfoSchema,
  validatedAt: z.iso.datetime({ offset: true }).nullish(),
  validatedByUserId: z.uuid().nullish(),
});
